import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'hooks/useToast';
import AuthAPI from 'services/API/AuthAPI';

type ResetPasswordVariables = {
  resetToken: string;
  password: string;
};

export const usePasswordReset = () => {
  const { renderCustomToast: toast } = useToast();
  const navigate = useNavigate();

  return useMutation<void, Error, ResetPasswordVariables>(
    async ({ resetToken, password }) => {
      await AuthAPI.postPasswordResetSetNewPassword({
        token: resetToken,
        newPassword: password,
      });
    },
    {
      onSuccess: () => {
        toast({
          title: 'Success',
          description: 'Your password has been reset successfully.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
        navigate('/login');
      },
      onError: (error: any) => {
        const errorMsg = error.response?.data?.error;

        toast({
          title: 'Error',
          description:
            errorMsg || 'There was an error resetting your password. Please try again.',
          status: 'error',
          duration: null,
          isClosable: true,
        });
      },
    },
  );
};
